import { shouldRenderTestIds } from 'chairisher/context/site';

/**
 * Returns data-testid attributes when test IDs are enabled; otherwise {}.
 *
 * @param {string} testId
 * @returns {Object<string, string>}
 */
export function renderTestId(testId) {
    if (shouldRenderTestIds() && testId) {
        return { 'data-testid': testId };
    }
    return {};
}

/**
 * Sets or clears data-testid on an element to match the Django testid filter.
 *
 * @param {Element} element
 * @param {string} testId
 */
export function applyTestId(element, testId) {
    if (element) {
        if (shouldRenderTestIds() && testId) {
            element.setAttribute('data-testid', testId);
        } else {
            element.removeAttribute('data-testid');
        }
    }
}
